import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';

export const Lists_HE =
{
    Properties:
    {
        Language: EnumLanguages.Hebrew
    }
   
}